import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SmallChip } from '../../components/chips/SmallChip';
import styles from './nav_document_analyzer_text.module.scss';

export const NavDocumentAnalyzerText: FC = () => (
  <>
    <span className={styles.chip}>
      <SmallChip>
        <FormattedMessage id="navigation/document-analyzer/NavDocumentAnalyzerText.tsx/1" />
      </SmallChip>
    </span>
    {`Document\u00A0Analyzer`}
  </>
);
